import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { requestSearchPlayload } from '../../shared/models/model';
import { SearchService } from '../../shared/services/search.service';
import { Search } from '../../shared/models/model';
import { FormsModule } from '@angular/forms';
import { CommonDataService } from '../../shared/services/common-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [FormsModule, CommonModule, RouterModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnDestroy {
  searchedData: Search[] = [];
  displayedItems: Search[] = [];
  private dataSubscription: Subscription = new Subscription(); // Subscription to hold the data from common data service
  errorMessage: string | undefined;
  result: any;
  public searchedText: string = '';
  public inputSearchTerm: string = '';
  itemsPerPage: number = 10;
  currentPage: number = 0;
  searchSubscription: Subscription = new Subscription();
  constructor(
    private _router: Router,
    private _commonDataService: CommonDataService,
    private _searchService: SearchService,
  ) {}

  ngOnInit() {
    this.dataSubscription = this._commonDataService.s_data$.subscribe((data) => {
      this.searchedText = data;
      this.inputSearchTerm = data;
      this.getSearchResults(this.searchedText);
    });
  }

  viewMore() {
    // Increment the current page and fetch the next set of items
    this.currentPage++;
    const startIndex = this.currentPage * this.itemsPerPage;
    const nextItems = this.searchedData.slice(startIndex, startIndex + this.itemsPerPage);
    this.displayedItems = [...this.displayedItems, ...nextItems];
  }

  hasMoreItems(): boolean {
    const startIndex = (this.currentPage + 1) * this.itemsPerPage;
    return this.searchedData.length > startIndex;
  }

  // Fetching the search results
  getSearchResults(_searchedValue: string) {
    // payload for fetching search results
    this.currentPage = 0;
    if (!_searchedValue) return; // If the search value is empty, do nothing
    const payLoad: requestSearchPlayload = {
      requestingSystem: 'FinPro',
      searchTerm: _searchedValue,
    };

    this.searchSubscription = this._searchService.fetchSearchResults(payLoad).subscribe(
      (data: any) => {
        if (data) {
          this.searchedData = data.searchResults;
          this.displayedItems = this.searchedData.slice(0, this.itemsPerPage);
        }
      },
      // Error handling
      (error: string) => {
        this.errorMessage = error;
      },
    );
  }

  ngOnDestroy() {
    // Ensure to unsubscribe when the component is destroyed
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}
